 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		43: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"b2e984c5","1":"bbdb3f9cff11f5a7127aa4ce3ed28d4b92165163","2":"319554d1804d6d63ddf2ce9de43fbcddc8aaaebe","3":"91f689b371b7d35c34b800af0b32bfa4c5982ebd","4":"66c20aec8ff5173a67e0b209bfa0292c7ab21648","5":"629da014ade601b73346441d549c543cd6d4ad7a","6":"aa8cee8eded9dcefa6f0cce8f57fe6f2c6b26cf7","7":"da20930bf8b5c73fdcb3afaa2e18f81e17e9d80f","8":"f4eacda2173c6f7e3261e0a55f9eb94c585da86d","10":"component---cache-caches-gatsby-plugin-offline-app-shell-js","11":"component---src-pages-404-js","12":"component---src-pages-anjo-da-guarda-js","13":"component---src-pages-ascendente-js","14":"component---src-pages-carta-do-dia-js","15":"component---src-pages-index-js","16":"component---src-pages-jogo-de-tarot-js","17":"component---src-pages-mapa-astral-create-js","18":"component---src-pages-mapa-astral-js","19":"component---src-pages-numerologia-js","20":"component---src-pages-oraculo-baralho-cigano-js","21":"component---src-pages-oraculo-cristais-js","22":"component---src-pages-oraculo-mesa-real-js","23":"component---src-pages-oraculo-runas-js","24":"component---src-pages-oraculo-tarot-da-sorte-js","25":"component---src-pages-oraculo-tarot-do-amor-js","26":"component---src-pages-oraculo-tarot-js","27":"component---src-pages-oraculo-tarot-sim-ou-nao-js","28":"component---src-pages-politica-de-privacidade-js","29":"component---src-pages-ranking-da-semana-js","30":"component---src-pages-signo-chines-js","31":"component---src-templates-anjos-list-js","32":"component---src-templates-anjos-single-js","33":"component---src-templates-artigos-list-js","34":"component---src-templates-artigos-single-js","35":"component---src-templates-compatibilidade-amorosa-list-js","36":"component---src-templates-compatibilidade-amorosa-single-js","37":"component---src-templates-horoscopo-list-js","38":"component---src-templates-horoscopo-single-js","39":"component---src-templates-oraculo-card-js","40":"component---src-templates-signo-chines-single-js"}[chunkId]||chunkId) + "-" + {"0":"5a7701e66137e83c4262","1":"518677bb71bc9259dc59","2":"65f7303a9c1a35af330b","3":"b3c0608c8e4ceb960440","4":"20cfe20204c6ef10aa5c","5":"1e6c865658229ac72b2f","6":"f748967b7470975fcc55","7":"241a9ae6310adb767010","8":"89c897e1dc87404cd9e3","10":"4ded85b782482dc4ea16","11":"fd86f4a452b37397a4bd","12":"5251ac7a9749f10b2717","13":"4c1b45c569fa4e6aa960","14":"fa6f6cc8e721bc800143","15":"c724b3c8c85f764ded35","16":"434354e64bb8c3b822e6","17":"d1f0afe99e510ce77134","18":"8dbcd0dac2d695b7773b","19":"502e60b815a372c5d1a9","20":"393c0d30fbd11ae0c042","21":"f22fbf90b04cc6dc8224","22":"de2fe34dbd6250a375d0","23":"1c6638167e00f27b9555","24":"b015de11618e401bf58c","25":"ce4ce0c8f9915932c543","26":"765113b3cf3c844758d1","27":"958b5d4896f61327f079","28":"097bedcf1b77b78fd8e9","29":"2784650aa65d6df9476e","30":"7252a06eee2b141505bb","31":"e1ddc7b6890469e6cbcd","32":"4c2d26e679f37e78d70c","33":"0e05c163a88371570d20","34":"978e7202e46a96e95807","35":"37adcb1e7f9b9bc50c83","36":"5174317b4df40190fa4f","37":"866989f80d34ec78b7a1","38":"4dbfa124d9e033488c85","39":"f4b08e46018f59b9ae8e","40":"2269f82ffe0ec45ddfbe"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
